<div id="processes" class="custom-sheet-container">
  <div
    class="sheet-header primary flex-row-space-between-center"
    (click)="onToggleShow()"
  >
    <div class="pl-12">{{ "PROCESSES.ONGOING_PROCESS" | translate }}</div>
    <mat-icon *ngIf="show" class="s-24 mr-12 icon-mat">minimize</mat-icon>
    <mat-icon *ngIf="!show" class="s-24 mr-12 icon-mat">maximize</mat-icon>
    <!-- <mat-icon color="warn" class="s-24 mr-12">warning</mat-icon> -->
  </div>

  <div *ngIf="show">
    <div *ngFor="let item of processes" class="">
      <div
        class="process-child-item flex-row-space-between-center"
        [ngClass]="item.status === 'error' ? 'warn' : ''"
      >
        <div>
          <div class="label-content mr-16">
            {{ item.label }}
          </div>
          <span class="sub_label-content mr-16 ml-8">
            {{ item?.sub_label }}
          </span>
        </div>
        <div class="flex-row-start-center">
          <mat-spinner
            *ngIf="item.status !== 'error'"
            [diameter]="28"
            class="mr-4"
            color="accent"
          ></mat-spinner>
          <!-- Per-row dismiss on every type/status (was print/download only):
               removes the Firebase node; a still-running job simply completes
               into nothing server-side. -->
          <button
            mat-icon-button
            matTooltip="{{
              (item.status === 'error'
                ? 'PROCESSES.DISMISS'
                : 'GENERIC.CANCEL'
              ) | translate
            }}"
            (click)="onCancelProcess(item)"
            class=""
          >
            <mat-icon class="s-20 icon-mat-darkmode">{{
              iconsService.getIcon(item.status === "error" ? "CLOSE" : "CANCEL")
            }}</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
